import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-forest-50 px-5 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-92" data-mp="4uqcgsut9wrq">
      <div className="mx-auto max-w-2xl rounded-3xl border-4 border-lime-200 bg-lime-100 p-7 text-center shadow-card sm:p-10" data-id="element-93" data-mp="9ttkmm638j3x">
        <ShieldCheckIcon className="mx-auto h-11 w-11 text-forest-700" aria-hidden="true" data-id="element-94" data-mp="eu8vn72wdeiq" />
        <h2 id="guarantee-title" className="mt-4 font-display text-2xl font-extrabold tracking-tight text-forest-800 sm:text-3xl" data-id="element-95" data-mp="jrhgxgjcdyo7">
          Garantía total de <span className="underline-hand underline-hand-gold" data-id="element-96" data-mp="nrrkkmjnwczw">7 días</span>
        </h2>

        <p className="mt-5 text-sm text-forest-900/80 sm:text-base" data-id="element-97" data-mp="smxdw6fe8ty0">
          Abrí los tomos. Revisá los bonos. Usalo para organizar tu próxima semana.
        </p>
        <p className="mt-4 text-sm text-forest-900/80 sm:text-base" data-id="element-98" data-mp="12kbjfazs3ybj">
          Si sentís que el material no es para vos o que no te aporta valor:
        </p>
        <p className="mt-3 font-display text-xl font-extrabold text-forest-800 sm:text-2xl" data-id="element-99" data-mp="25rnioykrkksr">
          Te devolvemos el 100% de tu dinero.
        </p>
        <p className="mt-2 font-hand text-2xl text-forest-700" data-id="element-100" data-mp="20r99hd7ff4t5">Sin vueltas. Sin complicaciones.</p>

        <p className="mt-6 text-[13px] leading-relaxed text-forest-900/70" data-id="element-101" data-mp="1vu9crswgveep">
          Porque si el material no te ayuda a planificar con más claridad, no queremos quedarnos con tu
          dinero.
        </p>
      </div>
    </section>;
}